export default __webpack_public_path__ + "static/media/step_study.fb001e11.png";